import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { router } from "@/router";
import { ref } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {
    const match = router.resolve('/ai/chat');
    console.log('Route match:', match);
    const winHeight = ref(window.innerHeight);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "page-404",
        style: _normalizeStyle({
          height: winHeight.value + 'px'
        })
      }, _cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "inner"
      }, [_createElementVNode("h1", null, "404"), _createElementVNode("h2", null, "饶了地球一圈，还是没有找到您要的页面")], -1)]), 4);
    };
  }
});